var map = {
	"./1 Thumbnail, title_ DEA dan BNN RI Gelar Narcotics Cyber Investigation Course.jpg": 75282,
	"./2 Thumbnail, title_ PPSDM BNN RI Terima Kunjungan Delegasi Parlemen ASEAN Pada Sidang AIPACODD Ke – 6.jpg": 55090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90717;